export default __webpack_public_path__ + "static/PPGoshaSans-Bold-f85f4135fbde0f005fcd8c8e9909d69f.woff2";